import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileSizePipePipe } from './file-size-pipe.pipe';

@NgModule({
  declarations: [FileSizePipePipe],
  imports: [CommonModule],
  exports: [FileSizePipePipe],
})
export class FileSizePipeModule {}
